import { ReactNode } from 'react';
import { guyTheme } from './theme';
import { GetBrandTheme } from '@leadflow/shared/theme/GetBrandTheme';

const ThemeProviderWrapper = ({ children }: { children: ReactNode }) => {
  return <GetBrandTheme brandTheme={guyTheme}>{children}</GetBrandTheme>;
};

export default ThemeProviderWrapper;
